import { SchoolTypesComponent } from './SchoolTypesComponent';

export function SchoolTypesComponentC() {
  return <SchoolTypesComponent />;
}
